export const Card = ({ children }) => {
    return (
        <div className="rounded max-w-[350px] min-w-[350px] shadow-sm border border-[#dee3ed] h-auto p-[10px] flex flex-col gap-[10px] bg-white">
            {children}
        </div>
    );
};
